import { postOrderDocMultiple } from '../../services/api/order.api';
import { transformOrderDocMultiple } from '../../transforms/order';
import { transformError } from '../../transforms/error';
import {
	POST_ORDER_DOC_MULTIPLE_REQUEST,
	POST_ORDER_DOC_MULTIPLE_SUCCESS,
	POST_ORDER_DOC_MULTIPLE_FAILURE,
} from '../types';

export default {
	namespaced: true,

	state: {
		isLoading: false,
		error: null,
		data: transformOrderDocMultiple({}),
	},

	mutations: {
		[POST_ORDER_DOC_MULTIPLE_REQUEST](state) {
			state.isLoading = true;
			state.error = null;
			state.data = [];
		},
		[POST_ORDER_DOC_MULTIPLE_SUCCESS](state, data) {
			state.isLoading = false;
			state.data = transformOrderDocMultiple(data);
		},
		[POST_ORDER_DOC_MULTIPLE_FAILURE](state, error) {
			state.isLoading = false;
			state.error = transformError(error);
		},
	},

	actions: {
		async getOrderDocMultiple({ commit }, params) {
			try {
				commit(POST_ORDER_DOC_MULTIPLE_REQUEST);
				const { data } = await postOrderDocMultiple(params);
				commit(POST_ORDER_DOC_MULTIPLE_SUCCESS, data);
			} catch (error) {
				commit(POST_ORDER_DOC_MULTIPLE_FAILURE, error);
			}
		},
	},
};